import moment from 'moment'

function create_transmission_file(school_code, session_annee, array_students, tranTYPE, session_ipr) {



// SORT OUT COUNT
    var tranCNT = array_students.length
    if (tranTYPE == 'DID') {tranCNT = tranCNT * 2}


    var strXML = ''

    strXML += '<?xml version="1.0" encoding="ISO-8859-1"?>'
    strXML += '<commande xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">'

    if (tranTYPE == 'OSA' || tranTYPE == 'SET'){
        strXML += '<sigleSysteme>SYSEC</sigleSysteme>' 
    } else {
        strXML += '<sigleSysteme>SOCRATE</sigleSysteme>'    
    }

    

    strXML += '<codeOrganismeTransmetteur>' + school_code + '</codeOrganismeTransmetteur>'
    strXML += '<formatDiffusionElectroniqueRapport>X</formatDiffusionElectroniqueRapport>'
    strXML += '<destination></destination>'
    strXML += '<demande codeTransactionDemandeService="TRA">'
    
    strXML += '<codeOrganismeTransmis>' + school_code + '</codeOrganismeTransmis>'

    if (tranTYPE == 'DID') {
        strXML += '<periode></periode>'
    } else {
        strXML += '<periode>' + session_annee + '</periode>'
    }
    

if (tranTYPE == 'DID') {
    strXML += '<typeTransaction>SD</typeTransaction>'    
} else if (tranTYPE == 'IPR') {
    strXML += '<typeTransaction>SI</typeTransaction>'
} else if (tranTYPE == 'ICR') {
    strXML += '<typeTransaction>CR</typeTransaction>'
} else if (tranTYPE == 'RCS') {
    strXML += '<typeTransaction>RS</typeTransaction>'
} else if (tranTYPE == 'OSA') {
    strXML += '<typeTransaction>OA</typeTransaction>'
} else if (tranTYPE == 'SET') {
    strXML += '<typeTransaction>ST</typeTransaction>'
}

    strXML += '<modeTraitementMaj>P</modeTraitementMaj>'
    strXML += '<nbTransactionsSystemeTransmises>' + tranCNT + '</nbTransactionsSystemeTransmises>'
    strXML += '<autresParametresDemandeService></autresParametresDemandeService>'

// DO IN ORDER !!!!

// DID
    for (var i = 0; i < array_students.length; i++) {
        if (array_students[i].tranTYPE == 'DID') { strXML += create_DID(school_code , array_students[i])}
    }

// CIT
    for (var i = 0; i < array_students.length; i++) {
        if (array_students[i].tranTYPE == 'CIT') { strXML += create_CIT(school_code , array_students[i])}
    }

// ADR
    for (var i = 0; i < array_students.length; i++) {
        if (array_students[i].tranTYPE == 'ADR') { strXML += create_ADR(school_code , array_students[i])}
    }

// IPR
    for (var i = 0; i < array_students.length; i++) {
        if (array_students[i].tranTYPE == 'IPR') { strXML += create_IPR(school_code , session_annee , array_students[i],session_ipr)}
    }

// ICR
    for (var i = 0; i < array_students.length; i++) {
        if (array_students[i].tranTYPE == 'ICR') { strXML += create_ICR(school_code , session_annee , array_students[i])}
    }

// RCS
    for (var i = 0; i < array_students.length; i++) {
        if (array_students[i].tranTYPE == 'RCS') { strXML += create_RCS(school_code , session_annee , array_students[i])}
    }

// CNS
for (var i = 0; i < array_students.length; i++) {
    if (array_students[i].tranTYPE == 'CNS') { strXML += create_CNS(school_code , session_annee , array_students[i])}
}

// OSA
for (var i = 0; i < array_students.length; i++) {
    if (array_students[i].tranTYPE == 'OSA') { strXML += create_OSA(school_code , session_annee , array_students[i])}
}

// SET
for (var i = 0; i < array_students.length; i++) {
    if (array_students[i].tranTYPE == 'SET') { strXML += create_SET(school_code , session_annee , array_students[i])}
}


    
    strXML += '</demande>'


// CHECK IF DID -- ADD ADR !
if (tranTYPE == 'DID') {
    strXML += '<demande codeTransactionDemandeService="TRA">'
    strXML += '<codeOrganismeTransmis>' + school_code + '</codeOrganismeTransmis>'
    strXML += '<periode>' + session_annee + '</periode>'
    strXML += '<typeTransaction>AD</typeTransaction>'
    strXML += '<modeTraitementMaj>P</modeTraitementMaj>'
    strXML += '<nbTransactionsSystemeTransmises>' + array_students.length + '</nbTransactionsSystemeTransmises>'
    strXML += '<autresParametresDemandeService></autresParametresDemandeService>'
    for (var i = 0; i < array_students.length; i++) {
        strXML += create_ADR(school_code , array_students[i], session_annee)
    }

    strXML += '</demande>'
    strXML += '</commande>'

} else  {
    
    strXML += '</commande>'
} 

    return strXML
}
// **** **** **** **** END CREATE MASTER FILE

function create_DID(school_code , stud) {

    var strXML = ''
 
    strXML += '<transactionSysteme idTransaction="' + stud.id + '" codeTransactionSysteme="DID">'
    strXML += '<codeOrganismeTransmis>' + school_code + '</codeOrganismeTransmis>'
    strXML += '<periode></periode>'
    strXML += '<parametreTransaction>'
    strXML += '<contenuTxCollecte>'

    strXML += '<txIdentification>'
    strXML += '<codeOperation>' + 'M' + '</codeOperation>'
    strXML += '<codePermanent>' + stud.data.student_CodePerm + '</codePermanent>'
    strXML += '<noDA>' + stud.data.student_NumAdmission + '</noDA>'
    strXML += '<nomFamille>' + stud.data.student_lNAME + '</nomFamille>'
    strXML += '<prenom>' + stud.data.student_fNAME + '</prenom>'
    strXML += '</txIdentification>'

    strXML += '<contenuTx>'
    strXML += '<contenuTxDID>'
    strXML += '<langueMaternelle>' + return_transmission_val(stud.data.matLang) + '</langueMaternelle>'
    strXML += '<langueParleePlusSouventMaison>' + return_transmission_val(stud.data.useLang) + '</langueParleePlusSouventMaison>'
    strXML += '</contenuTxDID>'
    strXML += '</contenuTx>'
    strXML += '</contenuTxCollecte>'
    strXML += '</parametreTransaction>'
    strXML += '</transactionSysteme>'


// CREATE THE CIT
    strXML += create_CIT(school_code , stud)

    // setTimeout(() => { strXML += create_CIT(school_code , stud) }, 500);
    // setTimeout(() => { strXML += create_ADR(school_code , stud) }, 1000);

    return strXML

}
// **** END DID 

function create_ADR(school_code , stud, session_annee) {

    var strXML = ''

    // ID
    var tID = stud.id.replace(/^.{3}/g, 'ADR');

    strXML += '<transactionSysteme idTransaction="' + tID + '" codeTransactionSysteme="ADR">'
    strXML += '<codeOrganismeTransmis>' + school_code + '</codeOrganismeTransmis>'
    strXML += '<periode>' + session_annee + '</periode>'
    strXML += '<parametreTransaction>'
    strXML += '<contenuTxCollecte>'

    strXML += '<txIdentification>'
    strXML += '<codeOperation>' + 'M'  + '</codeOperation>'
    strXML += '<codePermanent>' + stud.data.student_CodePerm + '</codePermanent>'
    strXML += '<noDA>' + stud.data.student_NumAdmission + '</noDA>'
    strXML += '<nomFamille>' + stud.data.student_lNAME + '</nomFamille>'
    strXML += '<prenom>' + stud.data.student_fNAME + '</prenom>'
    strXML += '</txIdentification>'

    strXML += '<contenuTx>'
    strXML += '<contenuTxADR>'
    strXML += '<numeroImmeuble>' + stud.data.student_rueNUM + '</numeroImmeuble>'
    strXML += '<nomRue>' + stud.data.student_Address + '</nomRue>'

    strXML += '<appartement>' + stud.data.student_apt + '</appartement>'
    strXML += '<villeVillageMunicipalite>' + stud.data.student_City + '</villeVillageMunicipalite>'
    strXML += '<codePostal>' + stud.data.student_Postal.replace(/ /g,"").replace(/-/g,"") + '</codePostal>'
    strXML += '<codeProvinceTerritoireCanada>' + return_transmission_val(stud.data.codePROVINCE) + '</codeProvinceTerritoireCanada>'
    // 
    strXML += '<numeroTelephonePersonnel>' + stud.data.student_TelHome.replace(/\D/g,'') + '</numeroTelephonePersonnel>'
    strXML += '<codePays>' + '001' + '</codePays>'

    strXML += '</contenuTxADR>'
    strXML += '</contenuTx>'
    strXML += '</contenuTxCollecte>'
    strXML += '</parametreTransaction>'
    strXML += '</transactionSysteme>'

    return strXML
}
// **** END ADR

function create_CIT(school_code , stud) {

    var strXML = ''

    // ID
    var tID = stud.id.replace(/^.{3}/g, 'CIT');

    strXML += '<transactionSysteme idTransaction="' + tID + '" codeTransactionSysteme="CIT">'
    strXML += '<codeOrganismeTransmis>' + school_code + '</codeOrganismeTransmis>'
    strXML += '<periode></periode>'
    strXML += '<parametreTransaction>'
    strXML += '<contenuTxCollecte>'

    strXML += '<txIdentification>'
    strXML += '<codeOperation>' + 'M' + '</codeOperation>'
    strXML += '<codePermanent>' + stud.data.student_CodePerm + '</codePermanent>'
    strXML += '<noDA>' + stud.data.student_NumAdmission + '</noDA>'
    strXML += '<nomFamille>' + stud.data.student_lNAME + '</nomFamille>'
    strXML += '<prenom>' + stud.data.student_fNAME + '</prenom>'
    strXML += '</txIdentification>'

    strXML += '<contenuTx>'
    strXML += '<contenuTxCIT>'
    strXML += '<statutLegalCanada>'
    strXML += '<statutLegalCanada>' + return_transmission_val(stud.data.status) + '</statutLegalCanada>'

    // NEEDED FOR CAN. - - - CHECK IF HAVE EXIT DT
    strXML += '<dateEntreeVigueur>' + moment(stud.data.status_entDATE).add(1,"days").format('YYYYMMDD') + '</dateEntreeVigueur>'
    if (stud.data.status_expDATE) {strXML += '<dateExpiration>' + moment(stud.data.status_expDATE).add(1,"days").format('YYYYMMDD') + '</dateExpiration>'}
    
    strXML += '</statutLegalCanada>'
    strXML += '<codePaysCitoyennete>' + return_transmission_val(stud.data.codePAYS) + '</codePaysCitoyennete>'

    strXML += '<critereStatutResidentQuebec>'
    strXML += '<critereStatutResidentQuebec>' + return_transmission_val(stud.data.criteria) + '</critereStatutResidentQuebec>'
    if (stud.data.criteria_entDATE) {strXML += '<dateEntreeVigueur>' + moment(stud.data.criteria_entDATE).add(1,"days").format('YYYYMMDD') + '</dateEntreeVigueur>'}
    if (stud.data.criteria_expDATE) {strXML += '<dateExpiration>' + moment(stud.data.criteria_expDATE).add(1,"days").format('YYYYMMDD') + '</dateExpiration>'}
    strXML += '</critereStatutResidentQuebec>'

    strXML += '<autorisationEtudierCanada>'
    strXML += '<autorisationEtudierCanada>' + return_transmission_val(stud.data.autoCAN) + '</autorisationEtudierCanada>'
    if (stud.data.autoCAN_entDATE) {strXML += '<dateEntreeVigueur>' + moment(stud.data.autoCAN_entDATE).add(1,"days").format('YYYYMMDD') + '</dateEntreeVigueur>'}
    if (stud.data.autoCAN_expDATE) {strXML += '<dateExpiration>' + moment(stud.data.autoCAN_expDATE).add(1,"days").format('YYYYMMDD') + '</dateExpiration>'}
    strXML += '</autorisationEtudierCanada>'

    strXML += '<autorisationEtudierQuebec>'
    strXML += '<autorisationEtudierQuebec>' + return_transmission_val(stud.data.autoQC) + '</autorisationEtudierQuebec>'
    if (stud.data.autoQC_entDATE) {strXML += '<dateEntreeVigueur>' + moment(stud.data.autoQC_entDATE).add(1,"days").format('YYYYMMDD') + '</dateEntreeVigueur>'}
    if (stud.data.autoQC_expDATE) {strXML += '<dateExpiration>' + moment(stud.data.autoQC_expDATE).add(1,"days").format('YYYYMMDD') + '</dateExpiration>'}
    strXML += '</autorisationEtudierQuebec>'

    strXML += '<ententeMobilite>'
    strXML += '<ententeMobilite>' + return_transmission_val(stud.data.mobilite) + '</ententeMobilite>'
    if (stud.data.mobilite_entDATE) {strXML += '<dateEntreeVigueur>' + moment(stud.data.mobilite_entDATE).add(1,"days").format('YYYYMMDD') + '</dateEntreeVigueur>'}
    if (stud.data.mobilite_expDATE) {strXML += '<dateExpiration>' + moment(stud.data.mobilite_expDATE).add(1,"days").format('YYYYMMDD') + '</dateExpiration>'}
    strXML += '</ententeMobilite>'

    strXML += '<conditionExemptionMontantForfaitaire>'
    strXML += '<conditionExemptionMontantForfaitaire>' + return_transmission_val(stud.data.exemption) + '</conditionExemptionMontantForfaitaire>'
    if (stud.data.exemption_entDATE) {strXML += '<dateEntreeVigueur>' + moment(stud.data.exemption_entDATE).add(1,"days").format('YYYYMMDD') + '</dateEntreeVigueur>'}
    if (stud.data.exemption_expDATE) {strXML += '<dateExpiration>' + moment(stud.data.exemption_expDATE).add(1,"days").format('YYYYMMDD') + '</dateExpiration>'}
    strXML += '</conditionExemptionMontantForfaitaire>'

    strXML += '<indicateurDetentionDocumentOfficiel>' + return_transmission_val(stud.data.document) + '</indicateurDetentionDocumentOfficiel>'
    strXML += '<codeOrganismeReferenceDonneesCitoyennete>' + return_transmission_val(stud.data.reference) + '</codeOrganismeReferenceDonneesCitoyennete>'
    strXML += '</contenuTxCIT>'
    strXML += '</contenuTx>'
    strXML += '</contenuTxCollecte>'
    strXML += '</parametreTransaction>'
    strXML += '</transactionSysteme>'

    return strXML
}

// function create_IPR(school_code, session_annee, array_students) {
function create_IPR(school_code , session_annee , stud, session_ipr) {

var strXML = ''

// strXML += '<?xml version="1.0" encoding="ISO-8859-1"?>'
// strXML += '<commande xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">'
// strXML += '<sigleSysteme>SOCRATE</sigleSysteme>'
// strXML += '<codeOrganismeTransmetteur>' + school_code + '</codeOrganismeTransmetteur>'
// strXML += '<formatDiffusionElectroniqueRapport>X</formatDiffusionElectroniqueRapport>'
// strXML += '<destination/>'
// strXML += '<demande codeTransactionDemandeService="TRA">'

// strXML += '<codeOrganismeTransmis>' + school_code + '</codeOrganismeTransmis>'
// strXML += '<periode>' + session_annee + '</periode>'
// strXML += '<typeTransaction>SI</typeTransaction>'
// strXML += '<modeTraitementMaj>P</modeTraitementMaj>'
// strXML += '<nbTransactionsSystemeTransmises>' + array_students.length + '</nbTransactionsSystemeTransmises>'
// strXML += '<autresParametresDemandeService/>'

// // START LOOP HERE !
// var i;
// for (i = 0; i < array_students.length; i++) {
// if (array_students[i].tranTYPE == 'IPR')
// {

    strXML += '<transactionSysteme codeTransactionSysteme="IPR" idTransaction="' + stud.id + '">'
    strXML += '<codeOrganismeTransmis>' + school_code + '</codeOrganismeTransmis>'
    strXML += '<periode>' + session_annee + '</periode>'
    strXML += '<parametreTransaction>'
    strXML += '<contenuTxCollecte>'

    strXML += '<txIdentification>'
    strXML += '<codeOperation>' + stud.operation + '</codeOperation>'
    strXML += '<codePermanent>' + stud.data.student_CodePerm + '</codePermanent>'
    strXML += '<noDA>' + stud.data.student_NumAdmission + '</noDA>'
    strXML += '<nomFamille>' + stud.data.student_lNAME + '</nomFamille>'
    strXML += '<prenom>' + stud.data.student_fNAME + '</prenom>'
    strXML += '</txIdentification>'

    strXML += '<contenuTx>'
    strXML += '<contenuTxIPR>'
    strXML += '<serviceEnseignement>' + return_transmission_val(stud.data.service) + '</serviceEnseignement>'
    strXML += '<codeProgrammeCollegial>' + stud.data.prog_CODE.replace(".","") + '</codeProgrammeCollegial>'
    strXML += '<anneeCivileVersionProgrammeCollegial>' + stud.data.prog_YEAR + '</anneeCivileVersionProgrammeCollegial>'
    strXML += '<numeroTrimestreProgrammeEtudes>' + session_ipr + '</numeroTrimestreProgrammeEtudes>'
    strXML += '<typeFrequentationScolaire>' + return_transmission_val(stud.data.typeScolaire) + '</typeFrequentationScolaire>'
    strXML += '<conditionsAdmissionProgramme>' + return_transmission_val(stud.data.conditionProgram) + '</conditionsAdmissionProgramme>'
    strXML += '<conditionSpecifiqueAdmissionAEC>' + return_transmission_val(stud.data.conditionAdmission) + '</conditionSpecifiqueAdmissionAEC>'
    strXML += '<situationEleveTempsPartielReputeTempsPlein>' + return_transmission_val(stud.data.situation) + '</situationEleveTempsPartielReputeTempsPlein>'
    strXML += '<indicateurATE>' + return_transmission_val(stud.data.indicatorATE) + '</indicateurATE>'
    strXML += '<indicateurCheminementDecBacc>' + return_transmission_val(stud.data.indicatorBACC) + '</indicateurCheminementDecBacc>'
    strXML += '<indicateurProgrammeRefereEmploiQuebec>' + return_transmission_val(stud.data.indicatorEMPLOY) + '</indicateurProgrammeRefereEmploiQuebec>'
    strXML += '<indicateurProgrammeRefereOrdreProfessionnel>' + return_transmission_val(stud.data.indicatorPRO) + '</indicateurProgrammeRefereOrdreProfessionnel>'
    strXML += '<indicateurMilieuCarceral>' + return_transmission_val(stud.data.indicatorCARC) + '</indicateurMilieuCarceral>'
    strXML += '<indicateurGroupeReligionSpecifique>' + return_transmission_val(stud.data.indicatorRELIGION) + '</indicateurGroupeReligionSpecifique>'
    strXML += '<indicateurVoyageAutourMonde>' + return_transmission_val(stud.data.indicatorVOYAGE) + '</indicateurVoyageAutourMonde>'
    strXML += '</contenuTxIPR>'
    strXML += '</contenuTx>'
    strXML += '</contenuTxCollecte>'
    strXML += '</parametreTransaction>'
    strXML += '</transactionSysteme>'

// } // END IF IPR
// } // END LOOP HERE !

// strXML += '</demande>'
// strXML += '</commande>'

return strXML 

}

function create_ICR(school_code, session_annee, stud) {

    var strXML = ''
    
//     strXML += '<?xml version="1.0" encoding="ISO-8859-1"?>'
//     strXML += '<commande xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">'
//     strXML += '<sigleSysteme>SOCRATE</sigleSysteme>'
//     strXML += '<codeOrganismeTransmetteur>' + school_code + '</codeOrganismeTransmetteur>'
//     strXML += '<formatDiffusionElectroniqueRapport>X</formatDiffusionElectroniqueRapport>'
//     strXML += '<destination/>'
//     strXML += '<demande codeTransactionDemandeService="TRA">'
    
//     strXML += '<codeOrganismeTransmis>' + school_code + '</codeOrganismeTransmis>'
//     strXML += '<periode>' + session_annee + '</periode>'
//     strXML += '<typeTransaction>SI</typeTransaction>'
//     strXML += '<modeTraitementMaj>P</modeTraitementMaj>'
//     strXML += '<nbTransactionsSystemeTransmises>' + array_students.length + '</nbTransactionsSystemeTransmises>'
//     strXML += '<autresParametresDemandeService/>'

// // START LOOP HERE !
// var i;
// for (i = 0; i < array_students.length; i++) {
// if (array_students[i].tranTYPE == 'ICR')
// {

    strXML += '<transactionSysteme codeTransactionSysteme="ICR" idTransaction="' + stud.id + '">'
    strXML += '<codeOrganismeTransmis>' + school_code + '</codeOrganismeTransmis>'
    strXML += '<periode>' + session_annee + '</periode>'
    strXML += '<parametreTransaction>'
    strXML += '<contenuTxCollecte>'
 
    strXML += '<txIdentification>'
    strXML += '<codeOperation>' + stud.operation + '</codeOperation>'
    strXML += '<codePermanent>' + stud.data.student_CodePerm + '</codePermanent>'
    strXML += '<noDA>' + stud.data.student_NumAdmission + '</noDA>'
    strXML += '<nomFamille>' + stud.data.student_lNAME + '</nomFamille>'
    strXML += '<prenom>' + stud.data.student_fNAME + '</prenom>'
    strXML += '</txIdentification>'

    strXML += '<contenuTx>'
    strXML += '<contenuTxICR>'

    strXML += '<serviceEnseignement>' + return_transmission_val(stud.data.service) + '</serviceEnseignement>'
    strXML += '<codeProgrammeCollegial>' + stud.data.prog_CODE.replace(".","") + '</codeProgrammeCollegial>'
    strXML += '<anneeCivileVersionProgrammeCollegial>' + stud.data.prog_YEAR + '</anneeCivileVersionProgrammeCollegial>'

    strXML += '<codeCoursCollegial>' + stud.data.cour_CODE.replace(/-/g,"") + '</codeCoursCollegial>'
    strXML += '<groupeHoraire>' + stud.data.group_ID + '</groupeHoraire>'
    strXML += '<typeComposanteFinancementCours>' + return_transmission_val(stud.data.typeFinance) + '</typeComposanteFinancementCours>'
    strXML += '<typeReconnaissanceAcquisCompetences>' + return_transmission_val(stud.data.typeFormation) + '</typeReconnaissanceAcquisCompetences>'
    strXML += '<modeEnseignementDistance>' + return_transmission_val(stud.data.mode) + '</modeEnseignementDistance>'
    strXML += '<indicateurIntentionSubstitution>' + return_transmission_val(stud.data.sub) + '</indicateurIntentionSubstitution>'
    strXML += '<situationEtudesOrganismePartenaire>' + return_transmission_val(stud.data.situationOrg) + '</situationEtudesOrganismePartenaire>'

    strXML += '</contenuTxICR>'
    strXML += '</contenuTx>'
    strXML += '</contenuTxCollecte>'
    strXML += '</parametreTransaction>'
    strXML += '</transactionSysteme>'

// } // END IF ICR
// } // END LOOP 

//     strXML += '</demande>'
//     strXML += '</commande>'
    
    return strXML 
    
    }

    function create_OSA(school_code, session_annee, stud) {


        var lang = "FR"
        if (stud.data.useLang == 'AN = Anglais') {lang = "AN"}

        var strXML = ''
        strXML += '<transactionSysteme codeTransactionSysteme="OSA" idTransaction="' + stud.id + '">'
        strXML += '<codeOrganismeTransmis>' + school_code + '</codeOrganismeTransmis>'
        strXML += '<periode>' + session_annee + '</periode>'
        strXML += '<parametreTransaction>'
        strXML += '<parametresTransactionOSA>'

        strXML += '<codeOperation>' + stud.operation + '</codeOperation>'
        strXML += '<codePermanent>' + stud.data.student_CodePerm + '</codePermanent>'
        strXML += '<nomFamille>' + stud.data.student_lNAME + '</nomFamille>'
        strXML += '<prenom>' + stud.data.student_fNAME + '</prenom>'
        strXML += '<noDA>' + stud.data.student_NumAdmission + '</noDA>'
        strXML += '<codeProgrammeCollegial>' + stud.data.prog_CODE.replace(".","") + '</codeProgrammeCollegial>'
        strXML += '<codeObjectifStandard>' + stud.data.comp_CODE + '</codeObjectifStandard>'
        strXML += '<natureAtteinteObjectifStandard>' + 'OA' + '</natureAtteinteObjectifStandard>'
        
        strXML += '</parametresTransactionOSA>'
        strXML += '</parametreTransaction>'
        strXML += '</transactionSysteme>'


        return strXML 

    } // END CREATE OSA


    function create_SET(school_code, session_annee, stud) {


        var lang = "FR"
        if (stud.data.useLang == 'AN = Anglais') {lang = "AN"}

        var strXML = ''
        strXML += '<transactionSysteme codeTransactionSysteme="SET" idTransaction="' + stud.id + '">'
        strXML += '<codeOrganismeTransmis>' + school_code + '</codeOrganismeTransmis>'
        strXML += '<periode>' + session_annee + '</periode>'
        strXML += '<parametreTransaction>'
        strXML += '<parametresTransactionSET>'

        strXML += '<codeOperation>' + stud.operation + '</codeOperation>'
        strXML += '<codePermanent>' + stud.data.student_CodePerm + '</codePermanent>'
        strXML += '<nomFamille>' + stud.data.student_lNAME + '</nomFamille>'
        strXML += '<prenom>' + stud.data.student_fNAME + '</prenom>'
        strXML += '<noDA>' + stud.data.student_NumAdmission + '</noDA>'
        strXML += '<codeProgrammeCollegial>' + stud.data.prog_CODE.replace(".","") + '</codeProgrammeCollegial>'
        strXML += '<typeDiplome>' + "AEC" + '</typeDiplome>'
        strXML += '<langueEnseignementProgramme>' + lang + '</langueEnseignementProgramme>'
        
        strXML += '</parametreTransactionSET>'
        strXML += '</parametreTransaction>'
        strXML += '</transactionSysteme>'


        return strXML 

    } // END CREATE SET






    function create_RCS(school_code, session_annee, stud) {

        var strXML = ''
        
    //     strXML += '<?xml version="1.0" encoding="ISO-8859-1"?>'
    //     strXML += '<commande xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">'
    //     strXML += '<sigleSysteme>SOCRATE</sigleSysteme>'
    //     strXML += '<codeOrganismeTransmetteur>' + school_code + '</codeOrganismeTransmetteur>'
    //     strXML += '<formatDiffusionElectroniqueRapport>X</formatDiffusionElectroniqueRapport>'
    //     strXML += '<destination/>'
    //     strXML += '<demande codeTransactionDemandeService="TRA">'
        
    //     strXML += '<codeOrganismeTransmis>' + school_code + '</codeOrganismeTransmis>'
    //     strXML += '<periode>' + session_annee + '</periode>'
    //     strXML += '<typeTransaction>SI</typeTransaction>'
    //     strXML += '<modeTraitementMaj>P</modeTraitementMaj>'
    //     strXML += '<nbTransactionsSystemeTransmises>' + array_students.length + '</nbTransactionsSystemeTransmises>'
    //     strXML += '<autresParametresDemandeService/>'
    
    // // START LOOP HERE !
    // var i;
    // for (i = 0; i < array_students.length; i++) {
    // if (stud.tranTYPE == 'RCS')
    // {

        strXML += '<transactionSysteme codeTransactionSysteme="RCS" idTransaction="' + stud.id + '">'
        strXML += '<codeOrganismeTransmis>' + school_code + '</codeOrganismeTransmis>'
        strXML += '<periode>' + session_annee + '</periode>'
        strXML += '<parametreTransaction>'
        strXML += '<contenuTxCollecte>'
     
        strXML += '<txIdentification>'
        strXML += '<codeOperation>' + stud.operation + '</codeOperation>'
        strXML += '<codePermanent>' + stud.data.student_CodePerm + '</codePermanent>'
        strXML += '<noDA>' + stud.data.student_NumAdmission + '</noDA>'
        strXML += '<nomFamille>' + stud.data.student_lNAME + '</nomFamille>'
        strXML += '<prenom>' + stud.data.student_fNAME + '</prenom>'
        strXML += '</txIdentification>'
    
        strXML += '<contenuTx>'
        strXML += '<contenuTxRCS>'
    
        strXML += '<serviceEnseignement>' + return_transmission_val(stud.data.service) + '</serviceEnseignement>'
        strXML += '<codeProgrammeCollegial>' + stud.data.prog_CODE.replace(".","") + '</codeProgrammeCollegial>'
        strXML += '<anneeCivileVersionProgrammeCollegial>' + stud.data.prog_YEAR + '</anneeCivileVersionProgrammeCollegial>'
        strXML += '<codeCoursCollegial>' + stud.data.cour_CODE.replace(/-/g,"") + '</codeCoursCollegial>'
        strXML += '<groupeHoraire>' + stud.data.group_ID + '</groupeHoraire>'
        
        strXML += '<groupeEvaluation>' + stud.data.group_ID + '0</groupeEvaluation>'
        strXML += '<noteScolaire>' + stud.data.cs_MARK + '</noteScolaire>'
        strXML += '<moyenneGroupeEvaluation>' + stud.data.group_AVG + '</moyenneGroupeEvaluation>'
        strXML += '<typeResultatCoursSuivi>' + stud.data.cs_REMARK + '</typeResultatCoursSuivi>'
        strXML += '<langueActivite>' + return_language(stud.data.group_LANG) + '</langueActivite>'
        strXML += '<indicateurPresenceEleve>O</indicateurPresenceEleve>'

        strXML += '</contenuTxRCS>'
        strXML += '</contenuTx>'
        strXML += '</contenuTxCollecte>'
        strXML += '</parametreTransaction>'
        strXML += '</transactionSysteme>'
    
    // } // END IF ICR
    // } // END LOOP 
    
    //     strXML += '</demande>'
    //     strXML += '</commande>'
        
        return strXML 
        
        }


function create_CNS(school_code , stud) {

    var strXML = ''

    strXML += '<transactionSysteme idTransaction="' + stud.id + '" codeTransactionSysteme="ADR">'
    strXML += '<codeOrganismeTransmis>' + school_code + '</codeOrganismeTransmis>'
    strXML += '<periode></periode>'
    strXML += '<parametreTransaction>'
    strXML += '<contenuTxCollecte>'

    strXML += '<txIdentification>'
    strXML += '<codeOperation>' + stud.operation + '</codeOperation>'
    strXML += '<codePermanent>' + stud.data.student_CodePerm + '</codePermanent>'
    strXML += '<noDA>' + stud.data.student_NumAdmission + '</noDA>'
    strXML += '<nomFamille>' + stud.data.student_lNAME + '</nomFamille>'
    strXML += '<prenom>' + stud.data.student_fNAME + '</prenom>'
    strXML += '</txIdentification>'

    strXML += '<contenuTx>'
    strXML += '<contenuTxCNS>'

    
    strXML += '<codeProgrammeCollegial>' + stud.data.prog_CODE.replace(".","") + '</codeProgrammeCollegial>'
    strXML += '<anneeCivileVersionProgrammeCollegial>' + stud.data.prog_YEAR + '</anneeCivileVersionProgrammeCollegial>'
    strXML += '<codeCoursCollegial>' + stud.data.cour_CODE.replace(/-/g,"") + '</codeCoursCollegial>'
    strXML += '<langueActivite>' + return_language(stud.data.group_LANG) + '</langueActivite>'

    strXML += '<typeCoursNonSuivi>EQ</typeCoursNonSuivi>'
    strXML += '</contenuTxCNS>'
    strXML += '</contenuTx>'
    strXML += '</contenuTxCollecte>'
    strXML += '</parametreTransaction>'
    strXML += '</transactionSysteme>'

    return strXML
}
// **** END CNS





function return_language(val) {
    if (val == 'E') {return "AN"} else {return "FR"}
}

function return_transmission_val(val) {
    if (!val){return ""}
    if (val.indexOf("=")==-1){return ""}

    var tSplit = val.split("=");
    if (tSplit.length < 0) {return ""}
    return tSplit[0].trim()
}



function create_IPR_X(school_code, session_annee, array_students) {

    var builder = require('xmlbuilder');
    var xml = builder.create('commande', {encoding: 'ISO-8859-1'})
        .att('xmlns:xsi', 'http://www.w3.org/2001/XMLSchema-instance')
        .ele('sigleSysteme', 'SOCRATE').up()
        .ele('codeOrganismeTransmetteur', school_code).up()
        .ele('formatDiffusionElectroniqueRapport', 'X').up()
        .ele('destination', '').up()
        
        .ele('demande', { 'codeTransactionDemandeService': 'TRA' })

        .ele('codeOrganismeTransmis', school_code).up()
        .ele('periode', session_annee).up()
        .ele('typeTransaction', 'SI').up()
        .ele('modeTraitementMaj', 'P').up()
        .ele('nbTransactionsSystemeTransmises', array_students.length).up()
        .ele('autresParametresDemandeService', '').up()



        .ele('transactionSysteme', { 'idTransaction': '0001', 'codeTransactionSysteme': 'IPR' }) // GET RANDOM ID !!!!
        .ele('codeOrganismeTransmis', school_code).up()
        .ele('periode', session_annee).up()

        .ele('parametreTransaction', '')
        .ele('contenuTxCollecte', '')
        .ele('txIdentification', '')

            .ele('codeOperation', 'P').up()
            .ele('codePermanent', 'P').up()
            .ele('noDA', 'P').up()
            .ele('nomFamille', 'P').up()
            .ele('prenom', 'P').up()

        .up() // txIdentification

        .ele('contenuTx', '')
        .ele('contenuTxIPR', '')

        .ele('serviceEnseignement', 'P').up()
        .ele('codeProgrammeCollegial', 'P').up()
        .ele('anneeCivileVersionProgrammeCollegial', 'P').up()
        .ele('numeroTrimestreProgrammeEtudes', 'P').up()
        .ele('typeFrequentationScolaire', 'P').up()
        .ele('conditionsAdmissionProgramme', 'P').up()
        .ele('conditionSpecifiqueAdmissionAEC', 'P').up()
        .ele('situationEleveTempsPartielReputeTempsPlein', 'P').up()
        .ele('indicateurATE', 'P').up()
        .ele('indicateurCheminementDecBacc', 'P').up()
        .ele('indicateurProgrammeRefereEmploiQuebec', 'P').up()
        .ele('indicateurProgrammeRefereOrdreProfessionnel', 'P').up()
        .ele('indicateurMilieuCarceral', 'P').up()
        .ele('indicateurVoyageAutourMonde', 'P').up()
        .ele('codeOperation', 'P').up()

        .up() // contenuTxIPR
        .up() // contenuTx

        .up() // contenuTxCollecte
        .up() // parametreTransaction
        .up() // transactionSysteme




        .up() // demande
        .up() // commande

      .end({ pretty: true});
     
       return xml // DISPLAY ON SCREEN  ./assets/

}

function create_ICR_X(school_code, session_annee, array_students) {

    var builder = require('xmlbuilder');
    var xml = builder.create('commande', {encoding: 'ISO-8859-1'})
        .att('xmlns:xsi', 'http://www.w3.org/2001/XMLSchema-instance')
        .ele('sigleSysteme', 'SOCRATE').up()
        .ele('codeOrganismeTransmetteur', school_code).up()
        .ele('formatDiffusionElectroniqueRapport', 'X').up()
        .ele('destination', '').up()
        
        .ele('demande', { 'codeTransactionDemandeService': 'TRA' })

        .ele('codeOrganismeTransmis', school_code).up()
        .ele('periode', session_annee).up()
        .ele('typeTransaction', 'SI').up()
        .ele('modeTraitementMaj', 'P').up()
        .ele('nbTransactionsSystemeTransmises', array_students.length).up()
        .ele('autresParametresDemandeService', '').up()

        .ele('transactionSysteme', { 'idTransaction': '0001', 'codeTransactionSysteme': 'ICR' }) // GET RANDOM ID !!!!
        .ele('codeOrganismeTransmis', school_code).up()
        .ele('periode', session_annee).up()

        .ele('parametreTransaction', '')
        .ele('contenuTxCollecte', '')
        .ele('txIdentification', '')
 
            .ele('codeOperation', 'P').up()
            .ele('codePermanent', 'P').up()
            .ele('noDA', 'P').up()
            .ele('nomFamille', 'P').up()
            .ele('prenom', 'P').up()

        .up() // txIdentification

        .ele('contenuTx', '')
        .ele('contenuTxICR', '')

        .ele('serviceEnseignement', 'P').up()
        .ele('codeProgrammeCollegial', 'P').up()  
        .ele('anneeCivileVersionProgrammeCollegial', 'P').up()

        .ele('codeCoursCollegial', 'P').up()
        .ele('groupeHoraire', 'P').up()
        .ele('typeComposanteFinancementCours', 'P').up()
        .ele('typeReconnaissanceAcquisCompetences', 'P').up()
        .ele('modeEnseignementDistance', 'P').up()
        .ele('indicateurIntentionSubstitution', 'P').up()
        .ele('situationEtudesOrganismePartenaire', 'P').up()

        .up() // contenuTxICR
        .up() // contenuTx

        .up() // contenuTxCollecte
        .up() // parametreTransaction
        .up() // transactionSysteme

        .up() // demande
        .up() // commande

      .end({ pretty: true});
     
       return xml // DISPLAY ON SCREEN  ./assets/

}



//export default {create_IPR , create_ICR, create_RCS}
export default {create_transmission_file}